import axios from 'axios';


const mode = process.env.REACT_APP_FLASK_ENV;
const BASE_URL = mode === 'production' ? '' : 'http://localhost:5055';

console.log("BASE_URL:", BASE_URL);

async function fetchData(apiEndpoint, config = {}) {
  try {
    const url = `${BASE_URL}${apiEndpoint}`;
    const response = await axios.get(url, {
      withCredentials: true,
      ...config,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

async function postData(apiEndpoint, data = {}, config = {}){
  try {
    const url = `${BASE_URL}${apiEndpoint}`;
    let response = await axios.post(url, data, {
      withCredentials: true,
      ...config,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

async function deleteData(apiEndpoint, config = {}){
  try {
    const url = `${BASE_URL}${apiEndpoint}`;
    let response = await axios.delete(url, {
      withCredentials: true,
      ...config,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

async function putData(apiEndpoint, data = {}, config = {}){
  try {
    const url = `${BASE_URL}${apiEndpoint}`;
    let response = await axios.put(url, data, {
      withCredentials: true,
      ...config,
    });
    return response;
  } catch (error) {
    throw error;
  }
}


export { fetchData, postData, putData, deleteData };
